<!-- PDf viewer container -->
<div class="pdf-container">
  <div *ngIf="toggle" class="pdf-content">
    <div class="pdf-status-container">
      <!-- Is being viewed Icon DEPRICATED ISH -->
      <!--<div [style.color]="(viewed)? '#ff4e4e': '#666766'" class="view-icon">
                <mat-icon [matTooltip]="(viewed)? 'This document is being watched!': 'No one is looking'"
                matTooltipPosition="above"
                matTooltipClass="pdf-tooltip">remove_red_eye</mat-icon>
            </div>-->

      <!-- Open In new tab -->
      <a (click)="togglePdf(false)" [href]="sanitize(blob)" target="_blank">
        <div class="open-new-tab-icon">
          <mat-icon
            matTooltip="open in new tab"
            matTooltipPosition="above"
            matTooltipClass="pdf-tooltip"
            >open_in_new</mat-icon
          >
        </div>
      </a>
    </div>
    <!-- The PDF being viewed -->
    <object class="pdf-viewer" type="application/pdf"></object>
  </div>
  <div *ngIf="!toggle">
    <!-- Open In new tab -->
    <a (click)="togglePdf(true)" style="cursor: pointer">
      <div class="toggle-open-icon">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </div>
    </a>
  </div>
</div>
